import { render } from "./Cards.vue?vue&type=template&id=5d3f9f34&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=5d3f9f34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d3f9f34"

export default script